import { useOutletContext } from "react-router-dom";
import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import { legal } from "../data/legal";
import { staticPath } from "../data";

export default function LegalPage({ pageKey }) {
  const { lang } = useOutletContext();
  const content = legal[pageKey][lang];
  const suffix = pageKey === "about" ? "" : " | BoingCars";

  return (
    <>
      <SEO
        lang={lang}
        title={`${content.title}${suffix}`}
        description={content.metaDesc}
        pathEn={staticPath("en", pageKey)}
        pathIt={staticPath("it", pageKey)}
      />
      <article className="container-site max-w-3xl py-16 md:py-24" data-testid={`legal-${pageKey}`}>
        <Reveal>
          <h1 className="font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">{content.title}</h1>
        </Reveal>
        <div className="mt-12 space-y-12">
          {content.body.map((block, idx) => (
            <Reveal key={idx} delay={idx * 0.05}>
              <section>
                <div className="flex items-baseline gap-4">
                  <span className="font-display text-sm font-extrabold text-ember">{String(idx + 1).padStart(2, "0")}</span>
                  <h2 className="font-display text-xl font-bold tracking-tight md:text-2xl">{block.h}</h2>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground md:text-base">{block.p}</p>
              </section>
            </Reveal>
          ))}
        </div>
      </article>
    </>
  );
}
